import http from '../../Common/api';

import { authenticatedUserUrl } from './constants';

const getUserInfo = async () => {
  try {
    const { firstName = '' } = await http.get(authenticatedUserUrl);

    return firstName;
  } catch (error) {
    return '';
  }
};

export default getUserInfo;
